import { render, staticRenderFns } from "./AirportBusCharter.vue?vue&type=template&id=1465288d&"
import script from "./AirportBusCharter.vue?vue&type=script&lang=ts&"
export * from "./AirportBusCharter.vue?vue&type=script&lang=ts&"
import style0 from "./AirportBusCharter.vue?vue&type=style&index=0&id=1465288d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports